export const getFullDate = (isoDate) => {
    const monthNames = ["Jan", "Feb", "March", "April", "May", "June", "July", "Aug", "Sept", "Oct", "Nov", "Dec"];
    var date = new Date(isoDate);
    return date.getDate() + ' ' + (monthNames[date.getMonth()]) + ' ' + date.getFullYear();
}


export const sendGA4Event = (eventName, params) => {
  if (typeof window !== "undefined" && typeof window.gtag === "function") {
    window.gtag("event", eventName, params);
  } else {
    console.warn("GA not ready; event skipped:", eventName, params);
  }
};
